import axios from "axios";
import FeatherIcon from 'feather-icons-react';
import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const studentName = (student) => {
    const user = student?.user || {};
    return [user.last_name, user.family_name, user.first_name]
        .filter(Boolean).join(" ").trim();
};

class SchoolfreeListClass extends Component{

    state = {
        isModal : false,
        formData : null,
        loading : true,
        schoolfeecategoryId : "",
        sectionclassId : "",
        schoolfees : [],
        schoolfeecategories : [],
        months : [],
        trimesters : [],
        type : 1,
        yearId : "",
        years : [],
    }

    componentDidMount(){
        this.getYears();
        this.getMonths();
        this.getTrimesters();
        this.getSchoolfreeCategories();
    }

    async getMonths(){
        var months = await axios.get("months");
        if(months.status === 200)
        {
            this.setState({
                months : months.data
            })
        }
    }

    async getYears(){
        var years = await axios.get("years");
        if(years.status === 200)
        {
            this.setState({
                years : years.data
            })
        }
    }

    async getTrimesters(){
        var trimesters = await axios.get("trimesters");
        if(trimesters.status === 200)
        {
            this.setState({
                trimesters : trimesters.data
            })
        }
    }

    getSchoolfrees = async(schoolfeecategoryId = this.state.schoolfeecategoryId, sectionclassId = this.state.sectionclassId) =>{
        if(!schoolfeecategoryId || !sectionclassId) return;

        this.setState({
            loading : false,
            schoolfeecategoryId : schoolfeecategoryId,
            sectionclassId : sectionclassId,
        })

        let schoolfees = await axios.get('/students/schoolfee/' + sectionclassId +'/' + schoolfeecategoryId+"/"+ this.state.yearId);
        if(schoolfees.status === 200)
            this.setState({ schoolfees : schoolfees.data , loading : true })
    }

    handleInput = (e) => {
        const { name, value } = e.target;
        const nextState = { [name]: value };

        if(name === "schoolfeecategoryId"){
            nextState.sectionclassId = "";
            nextState.schoolfees = [];
        }

        this.setState(nextState, () => {
            if(name === "sectionclassId" && value){
                this.getSchoolfrees(this.state.schoolfeecategoryId, value);
            }
        });
    }

    async getSchoolfreeCategories(){
        this.setState({schoolfeecategories : [] , loading : false}) 
        var schoolfeecategories = await axios.get('schoolfeecategories_/');
        if(schoolfeecategories.status === 200)
        {
            this.setState({schoolfeecategories : schoolfeecategories.data , loading : true}) 
        }
    }

    getClassOptions = (selectedCategory) => {
        const options = [];
        selectedCategory?.sectionschoolfeecategories?.forEach((sect) => {
            if(sect.transport){
                options.push({
                    id : sect.transport.id,
                    key : `transport-${sect.transport.id}`,
                    label : sect.transport.axe,
                    printLabel : `${sect.transport.axe} ${sect.price || ""}${sect.currency || ""}`.trim()
                });
                return;
            }

            sect.section?.sectionclasses?.forEach((sectionclass) => {
                const label = [
                    sectionclass.class?.short_entitled_class,
                    sectionclass.title,
                    sect.section?.entitled_section,
                    `${sect?.price || ""}${sect?.currency || ""}`
                ].filter(Boolean).join(" ");

                options.push({
                    id : sectionclass.id,
                    key : `${sect.id}-${sectionclass.id}`,
                    label,
                    printLabel : label
                });
            });
        });

        return options;
    }

    exportExcel = () => {

        let totalCdf = 0, totalUsd = 0;
        const selectedCategory = this.state.schoolfeecategories?.filter(val => String(val.id) === String(this.state.schoolfeecategoryId))[0];
        const classOptions = this.getClassOptions(selectedCategory);
        const isMonthly = String(this.state.type) === "1";
        const selectedClass = classOptions.filter(val => String(val.id) === String(this.state.sectionclassId))[0]?.printLabel;
                                        
        const rows = this.state.schoolfees?.sort((a, b) => a.user?.last_name + ' ' + a.user?.family_name + ' ' + a.user?.first_name > b.user?.last_name + ' ' + b.user?.family_name + ' ' + b.user?.first_name ? 1 : -1)?.map((student, count) => {
            let studentUsd = 0, studentCdf = 0;

            return({
                'N°': count + 1,
                'Nom et Post-Nom': studentName(student),
                ...isMonthly ? this.state.months?.reduce((acc, month) => {
                    let mount = 0, cdf = 0;
                    student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += schoolfree.pay_mount; });
                    student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += schoolfree.pay_mount; });
                    studentUsd += mount;
                    studentCdf += cdf;
                    acc[month.month] = `${mount > 0 ? mount?.toLocaleString() : ''} ${cdf > 0 ? cdf?.toLocaleString() : ''}`;
                    return acc;
                }, {}) : this.state.trimesters?.reduce((acc, trimester) => {
                    let mount = 0, cdf = 0;
                    student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += schoolfree.pay_mount; });
                    student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += schoolfree.pay_mount; });
                    studentUsd += mount;
                    studentCdf += cdf;
                    acc[trimester.short_trimester] = `${mount > 0 ? mount?.toLocaleString() : ''} ${cdf > 0 ? cdf?.toLocaleString() : ''}`;
                    return acc;
                }, {}),
                Total: `${studentUsd > 0 ? studentUsd?.toLocaleString() : ''} ${studentCdf > 0 ? studentCdf?.toLocaleString() : ''}`,
            })
        })
        rows.push({
            'N°': '',
            'Nom et Post-Nom': 'Total',
            ...isMonthly ? this.state.months?.reduce((acc, month) => {
                let mount = 0, cdf = 0;
                this.state.schoolfees.forEach((student) => {
                    student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += parseFloat(schoolfree.pay_mount); totalUsd += parseFloat(schoolfree.pay_mount); });
                    student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += parseFloat(schoolfree.pay_mount); totalCdf += parseFloat(schoolfree.pay_mount); });
                })
                acc[month.month] = `${ mount > 0 ? mount?.toLocaleString() : ""} ${ cdf > 0 ? cdf?.toLocaleString() : ""}`;
                return acc;
            }, {}) : this.state.trimesters?.reduce((acc, trimester) => {
                let mount = 0, cdf = 0;
                this.state.schoolfees.forEach((student) => {
                    student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += parseFloat(schoolfree.pay_mount); totalUsd += parseFloat(schoolfree.pay_mount); });
                    student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += parseFloat(schoolfree.pay_mount); totalCdf += parseFloat(schoolfree.pay_mount); });
                })
                acc[trimester.short_trimester] = `${ mount > 0 ? mount?.toLocaleString() : ""} ${ cdf > 0 ? cdf?.toLocaleString() : ""}`;
                return acc;
            }, {}),
            Total: `${ totalCdf > 0 ? totalCdf?.toLocaleString() : ''} ${ totalUsd > 0 ? totalUsd?.toLocaleString() : ''}`,
        });
        
        if (!rows.length) {
            toast("Sélectionnez au moins une salle contenant des élèves.", { theme: "light" });
            return;
        }
        const sheet = XLSX.utils.json_to_sheet(rows);
        const book = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(book, sheet, "Recouvrements");
        XLSX.writeFile(book,
            `evivesoma_recouvrements_${selectedClass || "inconnu"}_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };


    getTotals = () => {
        const totals = { usd : 0, cdf : 0 };
        this.state.schoolfees?.forEach((student) => {
            student.schoolfees?.forEach((schoolfree) => {
                const value = parseFloat(schoolfree.pay_mount || 0);
                if(schoolfree.sectionschoolfeecategory?.currency === "USD") totals.usd += value;
                if(schoolfree.sectionschoolfeecategory?.currency === "CDF") totals.cdf += value;
            });
        });
        return totals;
    }

    render(){
        const selectedCategory = this.state.schoolfeecategories?.filter(val => String(val.id) === String(this.state.schoolfeecategoryId))[0];
        const classOptions_ = this.getClassOptions(selectedCategory);
        // À placer juste avant le return de votre composant
        const classOptions = Array.from(
            new Map(classOptions_.map((item) => [item.id, item])).values()
        );
        const selectedClass = classOptions.filter(val => String(val.id) === String(this.state.sectionclassId))[0]?.printLabel;
        const isMonthly = String(this.state.type) === "1";
        const periodCount = isMonthly ? this.state.months?.length : this.state.trimesters?.length;
        const totals = this.getTotals();
        let totalCdf = 0, totalUsd = 0;

        return(
            <div className="finance-ledger-page schoolfee-recovery-page">
                <div className="finance-ledger-hero schoolfee-recovery-hero">
                    <div className="finance-ledger-hero__title">
                        <span className="ev-dashboard__eyebrow">Caisse scolaire</span>
                        <h1>Recouvrements { selectedCategory?.category && <span>{ selectedCategory.category }</span>}</h1>
                        <p>{ selectedClass || "Choisissez un frais et une classe pour afficher les paiements." }</p>
                    </div>

                    <div className="finance-ledger-hero__actions schoolfee-recovery-filters">

                        <label className="finance-ledger-select">
                            <FeatherIcon icon="calendar" size="16" />
                            <select name="yearId" value={ this.state.yearId } onChange={this.handleInput}>
                                <option value={ null }>Année </option>
                                {this.state.years.map((year) => <option key={year.id} value={year.id}>{ year.year }</option>)}
                            </select>
                        </label>

                        <label className="finance-ledger-select">
                            <FeatherIcon icon="calendar" size="16" />
                            <select name="type" value={ this.state.type } onChange={this.handleInput}>
                                <option value={ null }>Type </option>
                                <option value={1}>Mensuel</option>
                                <option value={2}>Trimestriel</option>
                            </select>
                        </label>

                        <label className="finance-ledger-select">
                            <FeatherIcon icon="credit-card" size="16" />
                            <select name="schoolfeecategoryId" value={ this.state.schoolfeecategoryId || "" } onChange={this.handleInput}>
                                <option value={ null }>Frais </option>
                                {this.state.schoolfeecategories.map((schoolfeecategory) => <option key={schoolfeecategory.id} value={schoolfeecategory.id}>{ schoolfeecategory.category }</option>)}
                            </select>
                        </label>

                        <label className="finance-ledger-select">
                            <FeatherIcon icon="layers" size="16" />
                            <select name="sectionclassId" value={ this.state.sectionclassId || "" } onChange={this.handleInput} disabled={!this.state.schoolfeecategoryId}>
                                <option value={ null }>Classe </option>
                                {classOptions.map((option) => <option key={option.key} value={option.id}>{ option.label }</option>)}
                            </select>
                        </label>

                        <button type="button" className="btn btn-sm btn-outline-primary finance-ledger-print" onClick={() => this.getSchoolfrees()}>
                            <FeatherIcon icon="server" size="17" /> <span>Afficher</span>
                        </button>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary finance-ledger-print" type="button"><FeatherIcon icon="printer" size="17" /> <span>Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                        <button className="btn btn-sm btn-outline-primary finance-ledger-print" type="button" onClick={() => this.exportExcel()}>
                            <FeatherIcon icon="printer" size="17" /> <span>Excel</span>
                        </button>
                    </div>
                </div>

                <div className="finance-ledger-stats schoolfee-recovery-stats">
                    <article><span><FeatherIcon icon="users" size="17" /></span><div><strong>{this.state.schoolfees?.length || 0}</strong><small>Eleves</small></div></article>
                    <article><span><FeatherIcon icon="grid" size="17" /></span><div><strong>{periodCount || 0}</strong><small>{isMonthly ? "Mois" : "Trimestres"}</small></div></article>
                    <article><span><FeatherIcon icon="dollar-sign" size="17" /></span><div><strong>{totals.usd.toLocaleString()} USD</strong><small>Total USD</small></div></article>
                    <article><span><FeatherIcon icon="briefcase" size="17" /></span><div><strong>{totals.cdf.toLocaleString()} CDF</strong><small>Total CDF</small></div></article>
                </div>

                <section className="finance-ledger-panel schoolfee-recovery-panel">
                    <div className="finance-ledger-panel__header">
                        <div>
                            <span>Liste des paiements</span>
                            <h2>{selectedClass || "Aucune classe selectionnee"}</h2>
                        </div>
                        <b>{this.state.loading ? `${this.state.schoolfees?.length || 0} ligne(s)` : "Chargement..."}</b>
                    </div>

                    <div ref={el => (this.componentRef = el)}>
                        <Headerpdf />
                        <UserIdentity title={ "Recouvrements " +  (selectedCategory?.category || "") + ' # ' + (selectedClass || "") } />
                        <div className="table-responsive finance-ledger-table-wrap schoolfee-recovery-table-wrap">
                            <table className="table table-sm finance-ledger-table schoolfee-recovery-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th scope="col">Eleve</th>
                                        {isMonthly ? this.state.months?.map(val => <th key={val.id}>{ val.month?.slice(0, 4) }</th>) : this.state.trimesters?.map(val => <th key={val.id}>{ val.short_trimester }</th>)}
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!this.state.loading && <tr><td colSpan={(periodCount || 0) + 3} className="finance-ledger-state"><FeatherIcon className="user-search-spin" icon="loader" /> Chargement des recouvrements...</td></tr>}
                                    {this.state.loading && this.state.schoolfees?.length === 0 && <tr><td colSpan={(periodCount || 0) + 3} className="finance-ledger-state">Selectionnez une classe pour afficher les recouvrements.</td></tr>}
                                    {this.state.schoolfees?.sort((a, b) => a.user?.last_name + ' ' + a.user?.family_name + ' ' + a.user?.first_name > b.user?.last_name + ' ' + b.user?.family_name + ' ' + b.user?.first_name ? 1 : -1).map((student, count) => {
                                        let studentUsd = 0, studentCdf = 0;

                                        return(
                                            <tr key={student.id}>
                                                <td align="right">{ count += 1}</td>
                                                <td><span className="finance-ledger-account">{ student?.user?.last_name } { student?.user?.family_name } { student?.user?.first_name }</span></td>
                                                {isMonthly ? this.state.months?.map((month) => {
                                                    let mount = 0, cdf = 0;
                                                    student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += schoolfree.pay_mount; });
                                                    student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += schoolfree.pay_mount; });
                                                    studentUsd += mount;
                                                    studentCdf += cdf;
                                                    return(<td key={month.id} className="finance-ledger-money">{ mount > 0 ? mount?.toLocaleString() : '' } { cdf > 0 ? cdf?.toLocaleString() : '' }</td>)
                                                }) : this.state.trimesters?.map((trimester) => {
                                                    let mount = 0, cdf = 0;
                                                    student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += schoolfree.pay_mount; });
                                                    student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += schoolfree.pay_mount; });
                                                    studentUsd += mount;
                                                    studentCdf += cdf;
                                                    return(<td key={trimester.id} className="finance-ledger-money">{ mount > 0 ? mount?.toLocaleString() : '' } { cdf > 0 ? cdf?.toLocaleString() : '' }</td>)
                                                })}
                                                <td className="finance-ledger-money is-balance">{ studentUsd > 0 ? studentUsd?.toLocaleString() : '' } { studentCdf > 0 ? studentCdf?.toLocaleString() : '' }</td>
                                            </tr>
                                        )
                                    })}
                                    <tr className="schoolfee-recovery-total-row">
                                        <th colSpan={2}>Total</th>
                                        {isMonthly ? this.state.months?.map(month =>{
                                            let mount = 0, cdf = 0;
                                            this.state.schoolfees.forEach((student) => {
                                                student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += parseFloat(schoolfree.pay_mount); totalUsd += parseFloat(schoolfree.pay_mount); });
                                                student.schoolfees?.filter(val => String(val.monthId) === String(month.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += parseFloat(schoolfree.pay_mount); totalCdf += parseFloat(schoolfree.pay_mount); });
                                            })
                                            return(<th key={month.id}>{ mount > 0 ? mount?.toLocaleString() : ""} { cdf > 0 ? cdf?.toLocaleString() : ""}</th>)
                                        }) : this.state.trimesters?.map(trimester =>{
                                            let mount = 0, cdf = 0;
                                            this.state.schoolfees.forEach((student) => {
                                                student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "USD")?.forEach((schoolfree) => { mount += parseFloat(schoolfree.pay_mount); totalUsd += parseFloat(schoolfree.pay_mount); });
                                                student.schoolfees?.filter(val => String(val.trimesectschool?.trimesterId) === String(trimester.id) && val.sectionschoolfeecategory.currency === "CDF")?.forEach((schoolfree) => { cdf += parseFloat(schoolfree.pay_mount); totalCdf += parseFloat(schoolfree.pay_mount); });
                                            })
                                            return(<th key={trimester.id}>{ mount > 0 ? mount?.toLocaleString() : ""} { cdf > 0 ? cdf?.toLocaleString() : ""}</th>)
                                        })}
                                        <th>{ totalCdf > 0 ? totalCdf?.toLocaleString() : ''} { totalUsd > 0 ? totalUsd?.toLocaleString() : ''} </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
export default SchoolfreeListClass;


